import type { UserRole } from '../types/user';

export interface Permission {
  id: string;
  name: string;
}

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  super_admin: [
    { id: 'manage_admins', name: 'Manage Administrators' },
    { id: 'system_backup', name: 'System Backup & Restore' },
    { id: 'create_projects', name: 'Create Projects' },
    { id: 'delete_projects', name: 'Delete Projects' },
    { id: 'manage_devices', name: 'Manage Devices' },
    { id: 'view_analytics', name: 'View Analytics' },
    { id: 'manage_users', name: 'Manage Users' },
    { id: 'manage_system', name: 'Manage System Settings' },
    { id: 'manage_security', name: 'Manage Security Settings' },
    { id: 'view_audit_logs', name: 'View Audit Logs' },
    { id: 'edit_projects', name: 'Edit Projects' },
    { id: 'view_projects', name: 'View All Projects' },
    { id: 'view_devices', name: 'View Devices' },
    { id: 'export_analytics', name: 'Export Analytics' },
    { id: 'assign_roles', name: 'Assign Roles' }
  ],
  admin: [
    { id: 'create_projects', name: 'Create Projects' },
    { id: 'edit_projects', name: 'Edit Projects' },
    { id: 'view_projects', name: 'View All Projects' },
    { id: 'manage_devices', name: 'Manage Devices' },
    { id: 'view_devices', name: 'View Devices' },
    { id: 'view_analytics', name: 'View Analytics' },
    { id: 'export_analytics', name: 'Export Analytics' },
    { id: 'manage_users', name: 'Manage Users' },
    { id: 'assign_roles', name: 'Assign Roles' }
  ],
  user: [
    { id: 'view_projects', name: 'View All Projects' },
    { id: 'view_devices', name: 'View Devices' },
    { id: 'view_analytics', name: 'View Analytics' }
  ],
  viewer: [
    { id: 'view_projects', name: 'View All Projects' },
    { id: 'view_analytics', name: 'View Analytics' }
  ]
}; 